const statusOptions = [
    { label: "Ganho", value: "won" },
    { label: "Perdido", value: "lost" },
    { label: "Aberto", value: "open" },
    { label: "Congelado", value: "frozen" }
];

export default statusOptions;